import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  jusitfy-items: center;
  div {
    display: flex;
    align-items: baseline;
    h3 {
      font-size: 1rem;
      margin-left: 0.4rem;
      margin-bottom: 0.5rem;
    }
  }

  p {
    font-size: 0.8rem;
    margin: ${({isMargin}) => (isMargin ? '' : '0')};
  }
`;
